"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCampaignServiceCreativeResponseToJSON = exports.CreateCampaignServiceCreativeResponseFromJSONTyped = exports.CreateCampaignServiceCreativeResponseFromJSON = exports.instanceOfCreateCampaignServiceCreativeResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CreateCampaignServiceCreativeResponse interface.
 */
function instanceOfCreateCampaignServiceCreativeResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCreateCampaignServiceCreativeResponse = instanceOfCreateCampaignServiceCreativeResponse;
function CreateCampaignServiceCreativeResponseFromJSON(json) {
    return CreateCampaignServiceCreativeResponseFromJSONTyped(json, false);
}
exports.CreateCampaignServiceCreativeResponseFromJSON = CreateCampaignServiceCreativeResponseFromJSON;
function CreateCampaignServiceCreativeResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
    };
}
exports.CreateCampaignServiceCreativeResponseFromJSONTyped = CreateCampaignServiceCreativeResponseFromJSONTyped;
function CreateCampaignServiceCreativeResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
    };
}
exports.CreateCampaignServiceCreativeResponseToJSON = CreateCampaignServiceCreativeResponseToJSON;
